import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CardComponent } from './components/card/card.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { WelcomeRoutingModule } from './welcome-routing.module';

@NgModule({
  imports: [
    SharedModule,
    WelcomeRoutingModule
  ],
  declarations: [
    WelcomeComponent,
    CardComponent
  ],
  providers: [
  ],
  exports: [
  ]
})
export class WelcomeModule { }
